
import React from "react";
import { ApparelProduct } from "@/types";
import ApparelProductGrid from "@/components/apparel/ApparelProductGrid";
import { ConnectionErrorAlert } from "@/components/common/ConnectionErrorAlert";
import ErrorBoundary from "@/components/common/ErrorBoundary";

interface ProductManagementContentProps {
  products: ApparelProduct[];
  categories: string[];
  loading: boolean;
  onEdit: (product: ApparelProduct) => void;
  onDelete: (product: ApparelProduct) => void;
  error?: Error | null;
}

export const ProductManagementContent: React.FC<ProductManagementContentProps> = ({
  products,
  categories,
  loading,
  onEdit,
  onDelete,
  error,
}) => {
  if (error) {
    return <ConnectionErrorAlert message="Failed to load products" />;
  }

  if (loading) {
    return (
      <div className="flex justify-center py-16">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-slate-600 font-medium">Loading products...</p>
        </div>
      </div>
    );
  }

  return (
    <ErrorBoundary
      componentName="ProductManagementContent"
      fallback={
        <ConnectionErrorAlert 
          message="Something went wrong while displaying products" 
          description="We encountered an error while trying to display the product list. Please try refreshing the page."
        />
      }
    >
      <ApparelProductGrid
        products={products}
        categories={categories}
        onEdit={onEdit}
        onDelete={onDelete}
        showAdminControls={true}
      />
    </ErrorBoundary>
  );
};
